
export const NEW_FILTER_FLUXO_CAIXA = 'NEW_FILTER_FLUXO_CAIXA'
export const NEW_FILTER_FLUXO_CAIXA_PENDING = 'NEW_FILTER_FLUXO_CAIXA_PENDING'
export const NEW_FILTER_FLUXO_CAIXA_SUCCESS = 'NEW_FILTER_FLUXO_CAIXA_SUCCESS'
export const NEW_FILTER_FLUXO_CAIXA_SUCCESS_PDF = 'NEW_FILTER_FLUXO_CAIXA_SUCCESS_PDF'
export const NEW_FILTER_FLUXO_CAIXA_FAILURE = 'NEW_FILTER_FLUXO_CAIXA_FAILURE'

export const NEW_FILTER_GRAFICO_FLUXO_CAIXA_PENDING = 'NEW_FILTER_GRAFICO_FLUXO_CAIXA_PENDING'
export const NEW_FILTER_GRAFICO_FLUXO_CAIXA_SUCCESS = 'NEW_FILTER_GRAFICO_FLUXO_CAIXA_SUCCESS'
export const NEW_FILTER_GRAFICO_FLUXO_CAIXA_FAILURE = 'NEW_FILTER_GRAFICO_FLUXO_CAIXA_FAILURE'